"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfileInStoreAction = exports.updateAccountInStore = exports.statusUpdateReceivedAction = exports.refreshAuthAction = exports.logoutTriggerAction = exports.loginTriggerAction = exports.MEMBER_PROFILE_UPDATE_STORE = exports.MEMBER_AUTH_UPDATE_STORE = exports.MEMBER_STATUS_UPDATE_RECEIVED = exports.MEMBER_TOKEN_PRELOAD = exports.MEMBER_AUTH_LOADED = exports.MEMBER_AUTH_REFRESH = exports.MEMBER_LOGOUT_TRIGGER = exports.MEMBER_TOKEN_LOADED = exports.MEMBER_LOGIN_TRIGGER = void 0;
var MEMBER_LOGIN_TRIGGER = 'MEMBER_LOGIN_TRIGGER';
exports.MEMBER_LOGIN_TRIGGER = MEMBER_LOGIN_TRIGGER;
var MEMBER_TOKEN_LOADED = 'MEMBER_TOKEN_LOADED';
exports.MEMBER_TOKEN_LOADED = MEMBER_TOKEN_LOADED;
var MEMBER_LOGOUT_TRIGGER = 'MEMBER_LOGOUT_TRIGGER';
exports.MEMBER_LOGOUT_TRIGGER = MEMBER_LOGOUT_TRIGGER;
var MEMBER_AUTH_REFRESH = 'MEMBER_AUTH_REFRESH';
exports.MEMBER_AUTH_REFRESH = MEMBER_AUTH_REFRESH;
var MEMBER_AUTH_LOADED = 'MEMBER_AUTH_LOADED';
exports.MEMBER_AUTH_LOADED = MEMBER_AUTH_LOADED;
var MEMBER_TOKEN_PRELOAD = 'MEMBER_TOKEN_PRELOAD';
exports.MEMBER_TOKEN_PRELOAD = MEMBER_TOKEN_PRELOAD;
var MEMBER_STATUS_UPDATE_RECEIVED = 'MEMBER_STATUS_UPDATE_RECEIVED';
exports.MEMBER_STATUS_UPDATE_RECEIVED = MEMBER_STATUS_UPDATE_RECEIVED;
var MEMBER_AUTH_UPDATE_STORE = 'MEMBER_AUTH_UPDATE_STORE';
exports.MEMBER_AUTH_UPDATE_STORE = MEMBER_AUTH_UPDATE_STORE;
var MEMBER_PROFILE_UPDATE_STORE = 'MEMBER_PROFILE_UPDATE_STORE';
exports.MEMBER_PROFILE_UPDATE_STORE = MEMBER_PROFILE_UPDATE_STORE;

var loginTriggerAction = function loginTriggerAction(token, account) {
  return {
    type: MEMBER_LOGIN_TRIGGER,
    payload: {
      token: token,
      account: account
    }
  };
};

exports.loginTriggerAction = loginTriggerAction;

var logoutTriggerAction = function logoutTriggerAction() {
  return {
    type: MEMBER_LOGOUT_TRIGGER,
    payload: {// token
    }
  };
};

exports.logoutTriggerAction = logoutTriggerAction;

var refreshAuthAction = function refreshAuthAction() {
  return {
    type: MEMBER_AUTH_REFRESH
  };
};

exports.refreshAuthAction = refreshAuthAction;

var statusUpdateReceivedAction = function statusUpdateReceivedAction(statusUpdate) {
  return {
    type: MEMBER_STATUS_UPDATE_RECEIVED,
    payload: statusUpdate
  };
};

exports.statusUpdateReceivedAction = statusUpdateReceivedAction;

var updateAccountInStore = function updateAccountInStore(account) {
  return {
    type: MEMBER_AUTH_UPDATE_STORE,
    payload: account
  };
};

exports.updateAccountInStore = updateAccountInStore;

var updateProfileInStoreAction = function updateProfileInStoreAction(profile) {
  return {
    type: MEMBER_PROFILE_UPDATE_STORE,
    payload: profile
  };
};

exports.updateProfileInStoreAction = updateProfileInStoreAction;